module.exports = __webpack_public_path__ + "static/media/upload.128cc063.svg";